import { Injectable } from '@angular/core';
import { AnalysesParentService } from './analyses-parent-service';
import { CountriesService } from 'src/app/navigation/services/countries-service';

@Injectable({ providedIn: 'root' })
export class ExpenseCalculationService extends AnalysesParentService {

  constructor(protected countriesService: CountriesService) {
    super();
  }

}
